import buttonEmpty from './src/main';

/* istanbul ignore next */
buttonEmpty.install = function(Vue) {
  Vue.component(buttonEmpty.name, buttonEmpty);
};
export default buttonEmpty;



// WEBPACK FOOTER //
// ./src/components/my-button-empty/index.js